// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
.appointments-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  text-align: center;
}
.appointments-empty__title {
  margin: 1.25rem 0 0;
  color: #999;
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.5;
}

.sectionTitle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0.5rem 1rem 1rem;
  font-size: 1rem;
  font-weight: 700;
  color: #333;
  text-align: left;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem 0.5rem;
}
.list .appointment {
  background: #ffffff;
  border-radius: 1.25rem;
  padding: 1.1rem;
  box-shadow: 0 6px 20px rgba(49, 49, 52, 0.09);
  cursor: pointer;
  transition: all 0.2s ease;
}
.list .appointment:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.list .appointment:hover {
  box-shadow: 0 8px 24px rgba(81, 85, 146, 0.14);
}
.list .appointment .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.list .appointment .card-header .datetime {
  display: flex;
  flex-direction: column;
}
.list .appointment .card-header .datetime .date {
  font-size: 0.75rem;
  color: rgb(178, 181, 188);
  font-weight: 500;
}
.list .appointment .card-header .datetime .time {
  font-size: 1.3rem;
  color: rgb(80, 80, 80);
  font-weight: 700;
}
.list .appointment .card-header .status-tag {
  display: flex;
  align-items: center;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.list .appointment .card-header .status-tag.PENDING {
  background: #e2b93b;
}
.list .appointment .card-header .status-tag.APPROVED {
  background: #4caf7d;
}
.list .appointment .divider {
  height: 1px;
  background: rgba(49, 49, 52, 0.08);
  margin-bottom: 0.75rem;
}
.list .appointment .info-grid {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}
.list .appointment .info-grid .info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.84rem;
}
.list .appointment .info-grid .info-row .label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: rgb(178, 181, 188);
  font-weight: 500;
}
.list .appointment .info-grid .info-row .label svg {
  flex-shrink: 0;
  color: #515592;
  opacity: 0.7;
}
.list .appointment .info-grid .info-row .value {
  color: rgb(80, 80, 80);
  font-weight: 600;
  text-align: right;
}
.list .appointment .info-grid .info-row .value--link {
  color: #515592;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.list .appointment .location-section {
  margin-top: 0.85rem;
  padding-top: 0.65rem;
  border-top: 1px solid rgba(49, 49, 52, 0.08);
  display: flex;
  align-items: center;
  gap: 0.4rem;
}
.list .appointment .location-section svg {
  flex-shrink: 0;
  color: #515592;
}
.list .appointment .location-section .address {
  font-size: 0.76rem;
  color: rgb(178, 181, 188);
  line-height: 1.4;
}
.list .appointment .location-section .address--link {
  color: #515592;
  text-decoration: underline;
  text-underline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/AppointmentList/AppointmentList.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_click-animation.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AAqEF;AAnEE;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAqEJ;;AAjEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAoEF;;AAjEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;AAoEF;AAlEE;EAEE,mBCxCI;EDyCJ,sBAAA;EACA,eAAA;EACA,6CAAA;EACA,eAAA;EACA,yBAAA;AAmEJ;AE/GE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFiHJ;AAtEI;EACE,8CAAA;AAwEN;AArEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAuEN;AArEM;EACE,aAAA;EACA,sBAAA;AAuER;AArEQ;EACE,kBAAA;EACA,yBC7DE;ED8DF,gBAAA;AAuEV;AApEQ;EACE,iBAAA;EACA,sBC5DO;ED6DP,gBAAA;AAsEV;AAlEM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;AAoER;AAlEQ;EACE,mBAAA;AAoEV;AAjEQ;EACE,mBAAA;AAmEV;AA9DI;EACE,WAAA;EACA,kCAAA;EACA,sBAAA;AAgEN;AA7DI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AA+DN;AA7DM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AA+DR;AA7DQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBClHE;EDmHF,gBAAA;AA+DV;AA7DU;EACE,cAAA;EACA,cAvHI;EAwHJ,YAAA;AA+DZ;AA3DQ;EACE,sBCtHO;EDuHP,gBAAA;EACA,iBAAA;AA6DV;AA3DU;EACE,cAlII;EAmIJ,0BAAA;EACA,0BAAA;AA6DZ;AAvDI;EACE,mBAAA;EACA,oBAAA;EACA,4CAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAyDN;AAvDM;EACE,cAAA;EACA,cApJQ;AA6MhB;AAtDM;EACE,kBAAA;EACA,yBCzJI;ED0JJ,gBAAA;AAwDR;AAtDQ;EACE,cA7JM;EA8JN,0BAAA;EACA,0BAAA;AAwDV","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme/';\n\n$brand_primary: #515592;\n\n.appointments-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1.5rem;\n  text-align: center;\n\n  &__title {\n    margin: 1.25rem 0 0;\n    color: #999;\n    font-size: 0.95rem;\n    font-weight: 500;\n    line-height: 1.5;\n  }\n}\n\n.sectionTitle {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0.5rem 1rem 1rem;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #333;\n  text-align: left;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 0 1rem 0.5rem;\n\n  .appointment {\n    @include click-animation;\n    background: $white;\n    border-radius: 1.25rem;\n    padding: 1.1rem;\n    box-shadow: 0 6px 20px rgba($light_shadow, 0.09);\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      box-shadow: 0 8px 24px rgba(81, 85, 146, 0.14);\n    }\n\n    .card-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 0.75rem;\n\n      .datetime {\n        display: flex;\n        flex-direction: column;\n\n        .date {\n          font-size: 0.75rem;\n          color: $text_gray;\n          font-weight: 500;\n        }\n\n        .time {\n          font-size: 1.3rem;\n          color: $unselectedText;\n          font-weight: 700;\n        }\n      }\n\n      .status-tag {\n        display: flex;\n        align-items: center;\n        font-size: 0.68rem;\n        font-weight: 700;\n        padding: 0.35rem 0.75rem;\n        border-radius: 20px;\n        color: #fff;\n        text-transform: uppercase;\n        letter-spacing: 0.4px;\n\n        &.PENDING {\n          background: #e2b93b;\n        }\n\n        &.APPROVED {\n          background: #4caf7d;\n        }\n      }\n    }\n\n    .divider {\n      height: 1px;\n      background: rgba($light_shadow, 0.08);\n      margin-bottom: 0.75rem;\n    }\n\n    .info-grid {\n      display: flex;\n      flex-direction: column;\n      gap: 0.55rem;\n\n      .info-row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 0.84rem;\n\n        .label {\n          display: flex;\n          align-items: center;\n          gap: 0.4rem;\n          color: $text_gray;\n          font-weight: 500;\n\n          svg {\n            flex-shrink: 0;\n            color: $brand_primary;\n            opacity: 0.7;\n          }\n        }\n\n        .value {\n          color: $unselectedText;\n          font-weight: 600;\n          text-align: right;\n\n          &--link {\n            color: $brand_primary;\n            text-decoration: underline;\n            text-underline-offset: 2px;\n          }\n        }\n      }\n    }\n\n    .location-section {\n      margin-top: 0.85rem;\n      padding-top: 0.65rem;\n      border-top: 1px solid rgba($light_shadow, 0.08);\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n\n      svg {\n        flex-shrink: 0;\n        color: $brand_primary;\n      }\n\n      .address {\n        font-size: 0.76rem;\n        color: $text_gray;\n        line-height: 1.4;\n\n        &--link {\n          color: $brand_primary;\n          text-decoration: underline;\n          text-underline-offset: 2px;\n        }\n      }\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin click-animation() {\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
